import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccordionModule } from '@epicuro-next/ataraxia/accordion';
import { AvatarModule } from '@epicuro-next/ataraxia/avatar';
import { BasketStatusBadgeModule } from '@epicuro-next/ataraxia/basket-status-badge';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { InfiniteScrollModule } from '@epicuro-next/ataraxia/infinite-scroll';
import { InputWithIconModule } from '@epicuro-next/ataraxia/input-with-icon';
import { LoaderOverlayModule } from '@epicuro-next/ataraxia/loader-overlay';
import { DataBasketsModule } from '@epicuro-next/data/baskets';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { BasketStateModule } from '@epicuro-next/state/basket-state';
import { BasketSwitchStateModule } from '@epicuro-next/state/basket-switch-state';

import { BasketSelectorComponent } from './components/basket-selector/basket-selector.component';
import { BasketsListComponent } from './components/baskets-list/baskets-list.component';
import { GroupedBasketsComponent } from './components/grouped-baskets/grouped-baskets.component';
import { SwitchBasketComponent } from './components/switch-basket/switch-basket.component';
import { BASKET_MANAGER_FEATURE_NAME } from './configurations';

@NgModule({
  imports: [
    CommonModule,
    AvatarModule,
    IconsModule,
    AccordionModule,
    BasketStateModule,
    DataBasketsModule,
    InputWithIconModule,
    InfiniteScrollModule,
    LoaderOverlayModule,
    BasketStatusBadgeModule,
    BasketSwitchStateModule,
    ConfigurationModule.forFeature(BASKET_MANAGER_FEATURE_NAME),
  ],
  declarations: [
    SwitchBasketComponent,
    GroupedBasketsComponent,
    BasketsListComponent,
    BasketSelectorComponent,
  ],
  exports: [SwitchBasketComponent],
})
export class FeatureBasketManagerModule {}
